import http from "../http-common";

class ProyectoService {

    get(id) {
        return http.get(`/proyecto/${id}`);
    }

    getAll() {
        return http.get('/proyecto');
    }

    delete(id) {
        return http.delete(`/proyecto/${id}`);
    }

    update(id) {
        return http.put(`/proyecto/${id}`)
    }

    create(data) {
        return http.post("/proyecto", data);
    }
}

export default new ProyectoService();